import React from 'react';
import hero_image from '../images/web_dev_hero_new.png';
import '../css/bg.css';

const PythonIcon = () => (
    <svg width="60" height="60" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M63.9 0C30.5 0 25.4 14.5 25.4 30.7V44H64.9V49H22.1C8.7 49 0 58.7 0 76.5C0 94.3 9.4 102 24.1 102H32.4V87C32.4 69.1 47.3 54.3 65.3 54.3H87.1C96.9 54.3 103 46.1 103 36.3V23C103 6.6 93.3 0 63.9 0ZM46.9 14.3C50.9 14.3 54.1 17.5 54.1 21.5C54.1 25.5 50.9 28.7 46.9 28.7C42.9 28.7 39.7 25.5 39.7 21.5C39.7 17.5 42.9 14.3 46.9 14.3Z" fill="#3776AB" />
        <path d="M64.1 128C97.5 128 102.6 113.5 102.6 97.3V84H63.1V79H105.9C119.3 79 128 69.3 128 51.5C128 33.7 118.6 26 103.9 26H95.6V41C95.6 58.9 80.7 73.7 62.7 73.7H40.9C31.1 73.7 25 81.9 25 91.7V105C25 121.4 34.7 128 64.1 128ZM81.1 113.7C77.1 113.7 73.9 110.5 73.9 106.5C73.9 102.5 77.1 99.3 81.1 99.3C85.1 99.3 88.3 102.5 88.3 106.5C88.3 110.5 85.1 113.7 81.1 113.7Z" fill="#FFD43B" />
    </svg>
);

const JavaIcon = () => (
    <div style={{ fontSize: '46px', color: '#f89820', userSelect: 'none' }}>☕</div>
);

const ReactIcon = () => (
    <svg viewBox="-11.5 -10.23174 23 20.46348" width="60" height="60" xmlns="http://www.w3.org/2000/svg">
        <circle cx="0" cy="0" r="2.05" fill="#61dafb" />
        <g stroke="#61dafb" strokeWidth="1" fill="none">
            <ellipse rx="11" ry="4.2" />
            <ellipse rx="11" ry="4.2" transform="rotate(60)" />
            <ellipse rx="11" ry="4.2" transform="rotate(120)" />
        </g>
    </svg>
);

const NodeIcon = () => (
    <svg viewBox="0 0 200 100" width="80" height="40" xmlns="http://www.w3.org/2000/svg">
        <rect width="200" height="100" rx="20" fill="#339933" />
        <text x="100" y="68" fill="white" fontSize="48" fontWeight="bold" textAnchor="middle" fontFamily="sans-serif">node.js</text>
    </svg>
);

const PhpIcon = () => (
    <svg viewBox="0 0 120 60" width="80" height="40" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="60" cy="30" rx="58" ry="28" fill="#777BB4" />
        <text x="60" y="40" fill="white" fontSize="28" fontWeight="bold" textAnchor="middle" fontFamily="sans-serif">php</text>
    </svg>
);

const services = [
    {
        title: "Website Development",
        icon: "💻",
        text: "We create, build, and maintain highly responsive websites tailored to your unique business needs and user expectations."
    },
    {
        title: "E-commerce Development",
        icon: "🛒",
        text: "Deliver seamless shopping experiences by building fast, secure, and scalable e-commerce platforms."
    },
    {
        title: "Website Management",
        icon: "⚙️",
        text: "We offer end-to-end management, ensuring your website remains secure, updated, and high-performing."
    }
];

const technologies = [
    { name: "Python", Icon: PythonIcon },
    { name: "Java", Icon: JavaIcon },
    { name: "React JS", Icon: ReactIcon },
    { name: "Node JS", Icon: NodeIcon },
    { name: "PHP", Icon: PhpIcon }
];

export default function webDev() {
    return (
        <div className='bg-light' style={{ minHeight: '100vh', paddingBottom: '60px' }}>

            {/* ── Hero Section ─────────────────────────── */}
            <div
                className="position-relative d-flex align-items-center justify-content-center text-center overflow-hidden"
                style={{
                    width: '100%',
                    height: '55vh',
                    backgroundImage: `url(${hero_image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    marginTop: '-1px'
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'linear-gradient(135deg, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.5) 100%)',
                        zIndex: 1
                    }}
                />
                <div className="container position-relative px-4" style={{ zIndex: 2 }}>
                    <p className="section-label animate-fade-up text-info mb-3">Digital Presence</p>
                    <h1 className="text-white fw-bold animate-fade-up delay-1" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', lineHeight: 1.1 }}>
                        WEB <span className="text-info">DEVELOPMENT</span>
                    </h1>
                    <p className="animate-fade-up delay-2 text-white-50 mt-4 mx-auto" style={{ maxWidth: '700px', fontSize: '1.15rem', lineHeight: 1.6 }}>
                        Web development facilitates the creation of robust web applications that enable users to interact with information and services seamlessly from anywhere.
                    </p>
                </div>
            </div>

            {/* ── Services Section ─────────────────────── */}
            <div className="container py-6 mt-5">
                <div className="text-center mb-5">
                    <p className="section-label">Our Expertise</p>
                    <h2 className="section-title">Web Development Services</h2>
                </div>

                <div className="row g-4 justify-content-center">
                    {services.map((service, index) => (
                        <div className="col-md-6 col-lg-4 d-flex" key={index}>
                            <div className="ftb-service-card w-100 p-4 text-center">
                                <div className="ftb-card-accent mb-3" />
                                <div style={{ fontSize: '3rem', margin: '15px 0' }}>{service.icon}</div>
                                <h5 className="fw-bold mb-3" style={{ color: 'var(--ftb-text)' }}>
                                    {service.title}
                                </h5>
                                <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.95rem', lineHeight: 1.6, textAlign: 'left' }}>
                                    {service.text}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Technologies Section ─────────────────── */}
            <div className="container-fluid py-5" style={{ background: 'var(--ftb-bg-alt)', transition: 'var(--transition)' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <p className="section-label">Tech Stack</p>
                        <h2 className="section-title">Development Technologies</h2>
                    </div>
                    <div className="row g-4 justify-content-center pt-3 text-center">
                        {technologies.map((tech, index) => {
                            const Icon = tech.Icon;
                            return (
                                <div className="col-6 col-md-4 col-lg-2" key={index}>
                                    <div className="d-flex flex-column align-items-center justify-content-center p-3 ftb-service-card h-100" style={{ minHeight: '160px' }}>
                                        <div style={{ height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '15px' }}>
                                            <Icon />
                                        </div>
                                        <p className="fw-semibold m-0" style={{ color: 'var(--ftb-text)' }}>{tech.name}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

        </div>
    )
}
